import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import Iframe from 'react-iframe';

import type { UploadFileResult } from '@revelio/data-access';

import { ModalDownloadButton } from './ModalDownloadButton';
import styles from './themedModal.module.css';

export type PptPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
} & Pick<UploadFileResult, 'previewUrl' | 'downloadUrl' | 'editUrl'>;

export const PptPreviewModal = ({
  isOpen,
  onClose,
  title,
  previewUrl,
  downloadUrl,
  editUrl,
}: PptPreviewModalProps) => {
  const iframeUrl = editUrl || previewUrl;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent className={styles.content} height="80%">
        <ModalHeader className={styles.header} fontSize="md" py={3} pl={4}>
          {title}
        </ModalHeader>
        <ModalCloseButton />
        {downloadUrl && <ModalDownloadButton downloadUrl={downloadUrl} />}
        <ModalBody padding={0} height="100%">
          {iframeUrl && (
            <Iframe
              id="ds-frame"
              url={iframeUrl}
              width="100%"
              height="100%"
              position="relative"
              styles={{ border: 'none' }}
              allowFullScreen
              allow="storage-access *"
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
